import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { MapboxGeoJSONFeature } from 'mapbox-gl';
import { arrayStringToArray } from '../../../util';
import { useSpring, animated } from 'react-spring';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import Anvendelse from './Anvendelse';

const Detaljer = (props: IDetaljerPropType) => {
  const { plan, accentColor, bgColor, show } = props;
  const ref = useRef(null);
  const { anvspec, bygomfang: bygomfangString } = plan.properties;
  const bygomfang = bygomfangString ? JSON.parse(bygomfangString) : [];
  const anvspecListe = arrayStringToArray(anvspec);
  const anvspecs = anvspecListe
    ? anvspecListe.map(a => {
      const bygomf = bygomfang.find(b => b.anvspec === parseInt(a));
      if (a) {
        return (
          <Anvendelse
            key={a}
            kode={parseInt(a)}
            bygomfang={bygomf}
            color={accentColor}
            bgColor={bgColor}
          />
        );
      }
      return null;
    })
    : null;
  const filterAnimation = useSpring({
    display: show ? 'block' : 'none',
    opacity: show ? 1 : 0,
  });
  useEffect(() => {
    if (show && ref && ref.current) {
      setTimeout(() => {
        scrollIntoView(ref.current, {
          scrollMode: 'if-needed',
          behavior: 'smooth',
          block: 'nearest',
        });
      }, 100);
    }
  }, [show]);
  return (
    <animated.div
      style={{
        ...{
          backgroundColor: '#FFF',
          borderBottom: '2px solid #D3DEE8',
          height: show ? 'auto' : undefined,
          padding: show ? '4px 0' : 0,
          overflow: 'hidden',
        },
        ...filterAnimation,
      }}
      ref={ref}
    >
      {anvspecs.length ? (
        <Anvendelser>{anvspecs}</Anvendelser>
      ) : (
          <div style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 20 }}>Ingen anvendelser</div>
        )}
    </animated.div>
  );
};

const Anvendelser = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
`;
interface IDetaljerPropType {
  plan: MapboxGeoJSONFeature;
  accentColor: string;
  bgColor: string;
  show: boolean;
}
export default Detaljer;
